<template>
  <VLayout row wrap>
    <VFlex :class="[flexStyles, 'daily-list-item--title cost-code-picklist']">
      <BasePicklist
        :disabled="disabled"
        :title="contractItemPicklistValue"
        :value="contractItemPicklistValue"
        :items="pickableItems"
        hint="Cost Code"
        item-text="PICKLIST_TITLE"
        :rules="[(v) => !!v || 'You must select a Cost Code']"
        v-on="$listeners"
        @input="
          $emit('update', {
            CONTRACT_ITEM: [
              {
                id: $event,
                identifier: pickableItems.find((item) => item.ID == $event)
                  .CONTRACT_ITEM,
              },
            ],
          })
        "
      />
    </VFlex>
    <VFlex :class="flexStyles">
      <ListItemDisplayOnly :value="unitType" hint="Unit Type" />
    </VFlex>
    <VFlex :class="flexStyles">
      <ListItemText
        :disabled="disabled"
        :value="asset.QUANTITY_COMPLETED"
        hint="Quantity Completed"
        @input="$emit('update', { QUANTITY_COMPLETED: $event })"
        @focus="$emit('startSaveTimer')"
      />
    </VFlex>
    <VFlex :class="flexStyles">
      <ListItemText
        :disabled="disabled"
        :value="asset.COMPLETION_NOTES"
        hint="Completion Notes"
        @input="$emit('update', { COMPLETION_NOTES: $event })"
        @focus="$emit('startSaveTimer')"
      />
    </VFlex>
  </VLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import _get from 'lodash/get'
import FlexStylesMixin from '@mixins/flex-styles'

export default {
  name: 'AssignmentRequisitionItem',
  mixins: [FlexStylesMixin(4)],
  props: {
    asset: {
      type: Object,
      required: true,
      default: () => {},
    },
    draft: {
      type: Object,
      required: true,
      default: () => {},
    },
    pickableItems: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['getContractItemById']),
    unitType() {
      let type = _get(this.contractItem, 'CONDITIONAL_UNIT_TYPE')
      if (_get(this.draft, 'CONTRACT_ITEM')) {
        let newId = _get(this.draft, 'CONTRACT_ITEM[0].id')
        let newItem = this.pickableItems.find((m) => m.ID === newId)
        type = _get(newItem, 'CONDITIONAL_UNIT_TYPE')
      }
      return type || ' - '
    }, // unitType
    contractItem() {
      let contractItemId = _get(this.asset, 'CONTRACT_ITEM[0].id', false)
      if (!contractItemId) {
        return null
      }
      return this.getContractItemById(contractItemId)
    },
    contractItemPicklistValue() {
      return _get(this.contractItem, 'PICKLIST_TITLE', '')
    },
    disabled() {
      return this.draft.isWorking || false
    }, // disabled
  },
}
</script>

<style lang="scss">
.cost-code-picklist .v-input {
  label,
  input {
    font-size: 13px;
    color: black;
    text-transform: uppercase;
  }
}
</style>
